import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Obtener el token de Mapbox del elemento input oculto
const accessToken = document.querySelector("#tokenmapboxevent")?.value;
if (accessToken) {
    mapboxgl.accessToken = accessToken;
}

document.addEventListener('DOMContentLoaded', function() {
    const mapContainer = document.getElementById('event-map');
    
    if (!mapContainer || !accessToken) return;

    const lat = parseFloat(mapContainer.dataset.lat);
    const lng = parseFloat(mapContainer.dataset.lng);
    const eventName = mapContainer.dataset.eventName || 'Evento';

    // Validar coordenadas
    if (isNaN(lat) || isNaN(lng) || !isFinite(lat) || !isFinite(lng)) {
        mapContainer.innerHTML = '<p class="text-center p-5">No hay ubicación disponible para este evento</p>';
        return;
    }

    const map = new mapboxgl.Map({
        container: 'event-map',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [lng, lat],
        zoom: 12
    });

    // Esperar a que el mapa cargue
    map.on('load', function() {
        // Crear popup con información del evento
        const popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML(`<strong>${eventName}</strong>`);

        // Crear marcador
        new mapboxgl.Marker()
            .setLngLat([lng, lat])
            .setPopup(popup)
            .addTo(map);
    });
});
